import { useMemo } from "react";
import { useLocation } from "react-router";

import { useFirstTouch } from "~/feature/attribution/hooks/useFirstTouch";
import type { ISignUpUnsafeMetadata } from "~/feature/auth/type";
import { buildSignUpUnsafeMetadata } from "~/feature/auth/utils/buildSignUpUnsafeMetadata";
import { resolveSignUpCampaign } from "~/feature/auth/utils/resolveSignUpCampaign";

export const useSignUpUnsafeMetadata = ():
  ISignUpUnsafeMetadata | undefined => {
  const { pathname, search } = useLocation();
  const signupCampaign = resolveSignUpCampaign(
    pathname,
    new URLSearchParams(search)
  );
  const firstTouch = useFirstTouch();

  return useMemo(
    () => buildSignUpUnsafeMetadata(signupCampaign, firstTouch),
    [signupCampaign, firstTouch]
  );
};
